//Logan函数
import Logan from 'logan-web';
Logan.initConfig({
  reportUrl: 'http://log.mfzcw.com/logan/web/upload.json',//'http://192.168.0.198:8080/logan_web_war/logan/web/upload.json',
  // publicKey: '-----BEGIN PUBLIC KEY-----\n' +
  //   'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgG2m5VVtZ4mHml3FB9foDRpDW7Pw\n' +
  //   'Foa+1eYN777rNmIdnmezQqHWIRVcnTRVjrgGt2ndP2cYT7MgmWpvr8IjgN0PZ6ng\n' +
  //   'MmKYGpapMqkxsnS/6Q8UZO4PQNlnsK2hSPoIDeJcHxDvo6Nelg+mRHEpD6K+1FIq\n' +
  //   'zvdwVPCcgK7UbZElAgMBAAE=\n' +
  //   '-----END PUBLIC KEY-----',
  errorHandler: function (e) { },
  succHandler: function (logItem) {
    let logItemTemp=JSON.parse(logItem.logContent)
    var content = logItemTemp.content;
    var logType = logItemTemp.logType;
    var encrypted = logItemTemp.encrypted;
    console.log('Log Succ:' + content);
    let date=new Date().getFullYear()+"-"+((new Date().getMonth()+1+"").length<2?("0"+(new Date().getMonth()+1)):(new Date().getMonth()+1))+"-"+((new Date().getDate()+"").length<2?("0"+new Date().getDate()):new Date().getDate());
    commonLogan.reportLoganLog(date,date);
  }
});

// const reportResult = await Logan.report({
//   reportUrl: 'https://yourServerAddressToAcceptLogs',
//   deviceId: 'LocalDeviceIdOrUnionId',
//   fromDayString: '2019-11-06',
//   toDayString: '2019-11-08',
//   webSource: 'Chrome',
//   environment: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/77.0.3865.120 Safari/537.36',
//   customInfo: JSON.stringify({userId: 123456, biz: 'Live Better'})
// });



export const commonLogan = {
  //logType：1-网络异常;2-代码逻辑异常
  loganLog(logContent,type) {
    // if (process.env.NODE_ENV === "development") {
    //   return;
    // }
    logContent=logContent+"~FromPage:"+window.location.href
    Logan.log(logContent, type);
  },
  reportLoganLog(fromDayString,toDayString) {
    let userInfo=commonObj.getUserInfo()
    Logan.report({
      // reportUrl: 'http://192.168.0.198:8080/logan_web_war/logan/web/upload.json',
      incrementalReport:true,
      deviceId: userInfo.name+"-"+userInfo.staffId+"(销售端)",//navigator.appVersion,
      fromDayString: fromDayString,//'2022-09-28',
      toDayString: toDayString,//'2022-09-28',
      webSource: 'Chrome',
      environment: "",//'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/77.0.3865.120 Safari/537.36',
      customInfo: JSON.stringify({})
    });
  }
}



// WEBPACK FOOTER //
// ./src/request/loganMethod.js